import React from 'react';
import cableApp from '../utility/cableApp';

export default function WithCable(WrappedComponent) {
  return (props) => <WrappedComponent {...props} cableApp={cableApp} />;
}
